import React, { useContext, useEffect } from "react";
import { SurveyContext } from "../../store/survey-context";
import { useTranslation } from "react-i18next";
import { setAppBackground } from "../../utils";
import Cta from "../../components/cta/Cta";
import "./surveyConfirmation.scss";

export default function SurveyConfirmation() {
  const { setVizAnimated } = useContext(SurveyContext);
  const { t } = useTranslation("common");

  useEffect(() => {
    setAppBackground(`Hero-1b.png`);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setVizAnimated(false);
  }, [setVizAnimated]);

  return (
    <div className="survey-confirmation">
      <div className="headline--secondary text-uppercase">{`${t(
        "start.line1"
      )} ${t("start.line2")} ${t("start.line3")}`}</div>

      <div className="easter-egg">
        <h1 className="headline--tertiary">
          {t("survey_confirmation.above")}{" "}
        </h1>
        <p className="easter-egg__below">{t("survey_confirmation.below")} </p>
      </div>

      <div className="survey-confirmation__button-container">
        <Cta
          path="/rings"
          ctaClass="cta--primary cta--centered"
          iconClass="icon-rings"
        >
          {t("survey_confirmation.see_your_journey_button")}
        </Cta>
        <Cta path="/questionnaire" ctaClass="cta--secondary cta--centered">
          {t("button.go_back")}
        </Cta>
      </div>
    </div>
  );
}
